import type { ObjectMetadata } from '@olytic/foundation';

import { formatMoney, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDateTime, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['price-grid-cells'];

/** One cell of a Price Grid: a fixed amount and hours for one Company Size (and quantity). Rationale: price-grid-cells.md. */
export const priceGridCells: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Cell',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('grid_name', 'Price Grid', { link: lookup('price-grids', 'grid_id') }),
    field('company_size', 'Company Size'),
    field('quantity', 'Quantity'),
    field('amount', 'Amount', { format: show(formatMoney) }),
    field('hours', 'Hours', { format: show((v) => formatNumber(v)) }),
    field('label', 'Label'),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['grid_name', 'company_size', 'quantity', 'amount', 'hours', 'label'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'grid_name'],
};
